import { Configuration, LogLevel } from '@azure/msal-browser';

const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : undefined;
const redirectUri = runtimeOrigin || process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_SPA_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

const apiClientId = process.env.REACT_APP_API_CLIENT_ID || '';
export const apiScope = process.env.REACT_APP_API_SCOPE || `api://${apiClientId}/access_as_user`;

export const loginRequest = {
  scopes: [apiScope],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
